import debounce from 'lodash.debounce';
import { BREAKPOINT_LG } from 'utils/breakpoint';

interface SearchTogglerProps {
    el: HTMLDivElement;
    props: {
        target: string;
    };
}

const DEBOUNCE_VALUE = 100;

const SearchToggler = ({ el, props }: SearchTogglerProps): void => {
    const { target } = props;

    const targetEl = document.querySelector(target) as HTMLDivElement | null;
    if (!targetEl) {
        return;
    }

    const closeSearch = (): void => {
        targetEl.classList.remove('is-open');
        el.classList.remove('disabled');
        el.setAttribute('aria-expanded', 'false');
    };

    const openSearch = (): void => {
        targetEl.classList.add('is-open');
        el.classList.remove('disabled');
        el.setAttribute('aria-expanded', 'true');
        const inputEl = targetEl.querySelector('input');
        if (!inputEl) {
            return;
        }
        // clean up the value and focus
        inputEl.value = '';
        inputEl.focus();
    };

    // set default as close if no is-open class
    if (!targetEl.classList.contains('is-open')) {
        el.setAttribute('aria-expanded', 'false');
    }

    el.addEventListener('click', () => {
        if (el.classList.contains('disabled')) {
            return;
        }

        if (targetEl.classList.contains('is-open')) {
            closeSearch();
        } else {
            openSearch();
        }
    });

    const windowResizeCheck = (): void => {
        // if menu is opened while transition from mobile to desktop, close the mobile nav
        if (window.innerWidth > BREAKPOINT_LG && targetEl.classList.contains('is-open')) {
            closeSearch();
        }
    };

    windowResizeCheck();
    window.addEventListener('resize', debounce(windowResizeCheck, DEBOUNCE_VALUE));
};

export default SearchToggler;
